<template>
  <button
    @click="handleClick"
    :class="['primery-button', buttonClass]"
  >
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  name: 'ButtonClose',
  props: {
      buttonText: {
          type: String,
          default: 'Close'
      },
      buttonClass: {
          type: String,
          default: ''
      },
      onClick: {
          type: Function,
          required: true
      }
  },
  methods: {
      handleClick() {
          this.onClick();
      }
  }
};
</script>
